class IngredientsList extends HTMLElement {
  constructor() {
    super();

    this.searchOptions = {
      valueNames: [
        'ingredient__type',
        'ingredient__name',
        { data: ['products'] },
      ],
    };

    this.onLoad = this.handleLoad.bind(this);
  }

  connectedCallback() {
    window.addEventListener('load', this.onLoad);
  }

  disconnectedCallback() {
    window.removeEventListener('load', this.onLoad);
  }

  handleLoad() {
    this.list = new window.List(this, this.searchOptions);
  }
}

customElements.define('ingredients-list', IngredientsList);

class IngredientCard extends HTMLElement {
  constructor() {
    super();
    this.transitionDuration = 0.5;
    this.image = this.querySelector('[data-image]');
    this.details = this.querySelector('[data-details]');

    if (!this.details) return;

    this.onMouseEnter = this.handleMouseEnter.bind(this);
    this.onMouseLeave = this.handleMouseLeave.bind(this);
    this.onResize = this.update.bind(this);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  bindEvents() {
    if (!this.details) return;

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    document.addEventListener('DOMContentLoaded', this.onResize);
    window.addEventListener('resize', this.onResize);
  }

  unbindEvents() {
    if (!this.details) return;
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    document.removeEventListener('DOMContentLoaded', this.onResize);
    window.removeEventListener('resize', this.onResize);
  }

  // TODO: Update duration based on height
  handleMouseEnter() {
    gsap.to(this.image, {
      height: this.imageHeight - this.detailsHeight,
      duration: this.transitionDuration,
    });
    gsap.to(this.details, {
      opacity: 1,
      duration: this.transitionDuration,
    });
  }

  handleMouseLeave() {
    gsap.to(this.image, {
      height: 'auto',
      duration: this.transitionDuration,
    });
    gsap.to(this.details, {
      opacity: 0,
      duration: this.transitionDuration,
    });
  }

  update() {
    this.imageHeight = this.image.offsetHeight;
    this.detailsHeight = this.details?.offsetHeight;

    gsap.set(this, { height: 'auto' });
    gsap.set(this, { height: this.offsetHeight });
  }
}

customElements.define('ingredient-card', IngredientCard);
